export const alignValues = ['start', 'center', 'end'];